import { jsx, jsxs } from "react/jsx-runtime";
import { Modal, TextInput, ModalButtonRow, Button } from "@flatfile/design-system";
import { useState } from "react";
import { useTranslation } from "react-i18next";
const SEARCH_MODAL_ID = "searchValueModal";
const SearchValueModalContent = (props) => {
  const { t } = useTranslation();
  const { columnConfig, columnIndex, onCancel, onSubmit } = props;
  const { label, value } = columnConfig[columnIndex];
  const [searchValue, setSearchValue] = useState("");
  const handleSubmit = async (event) => {
    event.preventDefault();
    onSubmit({ searchValue, searchField: value });
    onCancel == null ? void 0 : onCancel();
  };
  const handleChange = (value2) => {
    setSearchValue(value2);
  };
  return /* @__PURE__ */ jsxs("form", { onSubmit: handleSubmit, id: SEARCH_MODAL_ID, children: [
    /* @__PURE__ */ jsx(
      TextInput,
      {
        autoFocus: true,
        label: `${t(
          "sheet.table.contextMenu.searchInField.modal.searchWithin"
        )} ${label ?? value} (${value})`,
        placeholder: t(
          "sheet.table.contextMenu.searchInField.modal.placeholder"
        ),
        value: searchValue,
        onChange: handleChange
      }
    ),
    /* @__PURE__ */ jsxs(ModalButtonRow, { children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "tertiary-border",
          onPress: onCancel,
          label: t("sheet.table.contextMenu.searchInField.modal.cancelButton")
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          type: "submit",
          isDisabled: !searchValue,
          label: t("sheet.table.contextMenu.searchInField.modal.searchButton")
        }
      )
    ] })
  ] });
};
const SearchValueModal = (props) => {
  const content = SearchValueModalContent(props);
  return /* @__PURE__ */ jsx(Modal, { content });
};
export {
  SEARCH_MODAL_ID,
  SearchValueModal
};
